import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  style: {"height":"360px"},
  class: "CalendarContent"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "fl fs20 arial" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "mr5" }, "一括", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "dli_circle skyblue" }, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "mr5" }, "一括", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "dli_close pink" }, null, -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "fl fs14 ddgrey"
}
const _hoisted_13 = { class: "fl mt10 mb10" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = {
  style: {"height":"300px"},
  class: "CandidatesContent SelectModalPds"
}
const _hoisted_17 = {
  class: "centered",
  style: {"margin-top":"20px"}
}
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScheduleViewLoader = _resolveComponent("ScheduleViewLoader")!
  const _component_CalendarTable = _resolveComponent("CalendarTable")!
  const _component_TimezoneSelectContent = _resolveComponent("TimezoneSelectContent")!
  const _component_PossibleDateLi = _resolveComponent("PossibleDateLi")!
  const _component_WeeklyCalendarTable = _resolveComponent("WeeklyCalendarTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(`text mc`),
      style: _normalizeStyle({
                color: `#696969`,
                width: _ctx.isSP ? `100%` : ``,
            })
    }, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "posAb centered z1",
            style: _normalizeStyle({
                    height: _ctx.calendarShowType == `monthly` ? `360px` : `100px`,
                    width: _ctx.calendarShowType == `monthly` ? (_ctx.isSP ? `` : `350px`) : _ctx.isSP ? `calc(100% - 60px)` : `700px`,
                })
          }, [
            _createElementVNode("div", {
              class: "fw600 fs14 skyblue",
              style: _normalizeStyle({
                        marginTop: _ctx.calendarShowType == `monthly` ? `120px` : `40px`,
                    })
            }, [
              _createVNode(_component_ScheduleViewLoader),
              _hoisted_1,
              _createTextVNode(" 可能な日程を取得しています ")
            ], 4)
          ], 4))
        : _createCommentVNode("", true),
      (_ctx.calendarShowType == `monthly`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.pds)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(`${_ctx.isSP ? `mc w100` : `fl mr10`} ${_ctx.loading ? `op3` : ``}`),
                  style: _normalizeStyle({
                        height: `360px`,
                        width: _ctx.isSP ? `` : `350px`,
                    })
                }, [
                  _createElementVNode("section", _hoisted_3, [
                    _createVNode(_component_CalendarTable, {
                      ref: "CalendarTable",
                      monthlyPossibleDates: _ctx.monthlyPossibleDates,
                      idprefix: _ctx.idprefix,
                      onSelectDateFromCal: _ctx.selectDateFromCal,
                      onClickPrevMonth: _ctx.clickPrevMonth,
                      onClickNextMonth: _ctx.clickNextMonth
                    }, null, 8, ["monthlyPossibleDates", "idprefix", "onSelectDateFromCal", "onClickPrevMonth", "onClickNextMonth"])
                  ])
                ], 6))
              : _createCommentVNode("", true),
            (_ctx.Util.isPresent(_ctx.pds))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(` ${_ctx.isSP ? `centered mc w100` : `fl`} CandidatesContentOverwrap ofs`),
                  id: "CandidatesContentOverwrap",
                  style: _normalizeStyle({
                        height: `360px`,
                        width: _ctx.isSP ? `` : `${_ctx.pdWidth}px`,
                    })
                }, [
                  (_ctx.pdm.currentCalendarDate)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "mt10 fw600 ml10 pad10",
                        id: `${_ctx.idprefix}dateheader`
                      }, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.titleDate()), 1),
                        (_ctx.idprefix == `sel`)
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              class: "fl label skyblueBorder fs11 pointer mr3",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.allDaySelect && _ctx.allDaySelect(...args)))
                            }, _hoisted_8))
                          : _createCommentVNode("", true),
                        (_ctx.idprefix == `sel`)
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 1,
                              class: "fl label pinkBorder fs11 pointer",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.allDayDeselect && _ctx.allDayDeselect(...args)))
                            }, _hoisted_11))
                          : _createCommentVNode("", true),
                        (_ctx.idprefix == `top`)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.pdm?.room?.room_setting?.select_time_text || _ctx.$t(`message.select_time`)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_13, [
                          (_ctx.showChangeTimezone())
                            ? (_openBlock(), _createBlock(_component_TimezoneSelectContent, {
                                key: 0,
                                onSelectTimezone: _ctx.selectTimezone
                              }, null, 8, ["onSelectTimezone"]))
                            : _createCommentVNode("", true),
                          _hoisted_14
                        ]),
                        _hoisted_15
                      ], 8, _hoisted_4))
                    : _createCommentVNode("", true),
                  _createElementVNode("ul", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pds, (pd, pdindex) => {
                      return (_openBlock(), _createBlock(_component_PossibleDateLi, {
                        key: `${pd.jpFormat}${pd.selected}${pdindex}${_ctx.pds.length}${pd.tz_format}${_ctx.systemUpdatedAt}`,
                        showConfirmButton: _ctx.showConfirmButton,
                        useSelectbox: _ctx.useSelectbox,
                        pd: pd,
                        idprefix: _ctx.idprefix,
                        onConfirmFixSchedule: ($event: any) => (_ctx.confirmFixSchedule(pd)),
                        onClickCell: _ctx.clickPossibleDateCell,
                        onRemoveDate: _ctx.removeDate
                      }, null, 8, ["showConfirmButton", "useSelectbox", "pd", "idprefix", "onConfirmFixSchedule", "onClickCell", "onRemoveDate"]))
                    }), 128))
                  ])
                ], 6))
              : (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(`${_ctx.isSP ? `` : `fl`} CandidatesContentOverwrap`),
                  style: _normalizeStyle({
                        width: _ctx.isSP ? `` : `${_ctx.pdWidth}px`,
                    })
                }, [
                  _createElementVNode("p", _hoisted_17, [
                    _createTextVNode(" 表示できる設定可能な日程がありません。 "),
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                      width: "30",
                      height: "30"
                    }, null, 8, _hoisted_18)
                  ])
                ], 6))
          ]))
        : (_ctx.calendarShowType == `weekly`)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(`${_ctx.loading ? `op3` : ``}`)
            }, [
              _createVNode(_component_WeeklyCalendarTable, {
                useSelectbox: _ctx.useSelectbox,
                showConfirmButton: _ctx.showConfirmButton,
                idprefix: _ctx.idprefix,
                astag: _ctx.astag,
                onClickPrevWeek: _ctx.clickPrevWeek,
                onClickNextWeek: _ctx.clickNextWeek,
                onClickCell: _ctx.clickPossibleDateCell,
                onConfirmFixSchedule: _ctx.confirmFixSchedule
              }, null, 8, ["useSelectbox", "showConfirmButton", "idprefix", "astag", "onClickPrevWeek", "onClickNextWeek", "onClickCell", "onConfirmFixSchedule"])
            ], 2))
          : _createCommentVNode("", true)
    ], 4),
    _hoisted_19
  ]))
}